module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Дата":"Date","Статус":"Status","Тип платежа":"Payment type","Сумма":"Amount","Комиссия":"Commission","Управление":"Control","Платеж исполнен.":"Payment executed.","Платеж отклонен.":"Payment rejected.","Платеж в обработке.":"Payment in process.","Виртуальный платеж.":"Virtual payment."}}')
  delete Component.options._Ctor
}
